import isPlainValue from '../verifiers/is-plain-value';
import combineBatches from './combine-batches';
import convertPlainBatchToBreakpointBasedBatch from './convert-plain-batch-to-breakpoint-based-batch';

const splitBatchByValueType = (batch) => {
  const plainBatch = {};
  const breakpointBasedBatch = {};

  Object.entries(batch).forEach(([elementId, targets]) => {
    Object.entries(targets).forEach(([target, value]) => {
      const destination = isPlainValue(value) ? plainBatch : breakpointBasedBatch;

      if (!destination[elementId]) {
        destination[elementId] = {};
      }

      destination[elementId][target] = value;
    });
  });

  return { plainBatch, breakpointBasedBatch };
};

const enrichBatchToBreakpointBasedBatch = (batch, breakpointKey) => {
  const { plainBatch, breakpointBasedBatch } = splitBatchByValueType(batch);

  if (!Object.keys(plainBatch).length) {
    return breakpointBasedBatch;
  }

  return combineBatches([
    breakpointBasedBatch,
    convertPlainBatchToBreakpointBasedBatch(plainBatch, breakpointKey),
  ]);
};

export default enrichBatchToBreakpointBasedBatch;
